import React from 'react';
import MDEditor from '@uiw/react-md-editor';

interface MarkdownEditorProps {
   value: string;
   onChange: (value: string | undefined) => void;
}

const MarkdownEditor: React.FC<MarkdownEditorProps> = ({
   value,
   onChange,
}) => {
   return (
      <div data-color-mode="light">
         <MDEditor
            height={400}
            value={value}
            onChange={onChange}
            preview="edit"
            hideToolbar={false}
            style={{
               borderRadius: '12px',
               boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
               overflow: 'hidden',
            }}
         />

         {/* Vorschau getrennt */}
         {value &&
            <div style={{
               marginTop: "16px",
               padding: "16px",
               border: "1px solid #e0e0e0",
               borderRadius: "12px",
               backgroundColor: "white",
               boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
            }}>
               <MDEditor.Markdown source={value} />
            </div>
         }
      </div>
   );
};

export default MarkdownEditor;
